import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { RoleType } from '@lockton-apps/shared/interfaces';
import { SharedAuthFacade } from '../+state/auth.facade';
import { AuthSelectors } from '../..';
import { Store } from '@ngrx/store';
import { castArray } from 'lodash';

export type RoleGuardPredicate = (role: RoleType) => boolean;

export const roleGuardFn: CanActivateFn = (route) => {
  const authFacade = inject(SharedAuthFacade);
  const router = inject(Router);
  const { roleGuardPredicate, roleGuardRedirectRoute } = route.data;

  return authFacade.role$.pipe(
    map((role) => {
      if (roleGuardPredicate instanceof Function) {
        const route = Array.isArray(roleGuardRedirectRoute)
          ? roleGuardRedirectRoute
          : ['/'];

        return roleGuardPredicate(role) ? true : router.createUrlTree(route);
      }
      return true;
    })
  );
};

export function canMatchIfRole(
  role: RoleType,
  options?: { redirectUrl: string | string[] }
): CanMatchFn {
  return () => {
    const store = inject(Store);
    const router = inject(Router);

    return store.select(AuthSelectors.getRole).pipe(
      map((r) => {
        const canMatch = r === role;

        if (options && options.redirectUrl && !canMatch) {
          return router.createUrlTree(castArray(options.redirectUrl));
        }
        return canMatch;
      })
    );
  };
}
